<template>
  <div id="search">
    <header-nav></header-nav>
    <banner-component :banner-data="pageData"></banner-component>
    <div class="content">
      <!--左-->
      <article-side-bar :article-list-nav="pageData"></article-side-bar>
      <!-- <ul class="content_left">
        <li
            :class="curNav == item.id ? 'left_nav_active left_nav':'left_nav'"
            v-for="(item,index) in pageData.children" :key="item.id" @click="handleNav(item.id)">
          <router-link v-if="item.id == 4" :to="{path:'/location',query:{menuId:8,plateId:4}}">
            <span class="nav_name">地理位置</span>
          </router-link>
          <router-link v-else-if="item.id == 7" :to="{path:'/applyForEnter',query:{menuId:15,plateId:7}}">
            <span class="nav_name">申请入驻</span>
          </router-link>
          <router-link v-else :to="{path:'/articleList',query:{menuId:pageData.menuId,plateId:item.id}}">
            <span class="nav_name">{{item.plateName}}  &nbsp;</span>
            <img class="nav_img" src="../assets/images/article/navRight.png" alt="">
            <img class="white" src="../assets/images/article/whiteRight.png" alt="">
          </router-link>
        </li>
        <p class="search_box">
          <input class="search" type="text"  v-model="search">
          <router-link :to="{path:'/search',query:{menuId:pageData.menuId,plateId:curNav,search:this.search}}">
          <img @click="gosearch" class="search_img" src="../assets/images/article/search.png" alt="">
        </p>
      </ul> -->
      <!--右-->
      <div class="content_right">
        <div class="content_header">
          <span class="title">搜索结果</span>
          <span class="card">{{pageData.menuName}} > 搜索结果</span>
        </div>
        <ul v-if="$route.query.patent" class="article_box">
          <li class="article_list" v-for="(item,index) in articleList" :key="item.id">
            <router-link :to="{path:'/patentSearch/patentDetail',query:{menuId:$route.query.menuId,plateId:$route.query.plateId,id:item.id}}">
              <span class="article_title">
                <img src="../assets/images/article/articleRight.png" alt="">{{item.name}}
              </span>
              <span class="date">{{item.publishTime}}</span>
            </router-link>
          </li>
        </ul>
        <ul v-else class="article_box">
          <li class="article_list" v-for="(item,index) in articleList" :key="item.id">
            <router-link
                :to="{path:'/articleDetail',query:{menuId:item.menuId,plateId:item.plateId,articleId:item.articleId}}">
              <span class="article_title">
                <img src="../assets/images/article/articleRight.png" alt="">{{item.title}}
              </span>
              <span class="date">{{item.publishTime}}</span>
            </router-link>
          </li>
        </ul>
        <div class="data_null" v-if="articleList==''">
          暂无数据
        </div>
         <div class="page" v-else>
           <vue-pagination
               :current-page="currentPage"
               :total="totalPage"
               :page-size="pageSize"
               @current-change="handleChangeCurrent">
           </vue-pagination>
         </div>
      </div>
    </div>
    <partner-list></partner-list>
    <common-footer></common-footer>
  </div>
</template>

<script>
  import HeaderNav from '@/components/HeaderNav.vue'
  import CommonFooter from '@/components/CommonFooter.vue'
  import PartnerList from '@/components/PartnerList.vue'
  import BannerComponent from '@/components/BannerComponent.vue'
  import {searchArticleList} from '@/api/ArticleList.js'
  import { queryPatent } from '@/api/Patent.js'
  import ArticleSideBar from '@/components/ArticleSideBar.vue'

  export default {
    name: 'Search',
    components: {
      HeaderNav,
      CommonFooter,
      PartnerList,
      BannerComponent,
      ArticleSideBar
    },
    data() {
      return {
        articleList: [],
        plateName: '',
        articleId: '',
        currentPage:1,
        totalPage:100,
        pageSize:10,
      }
    },
    computed: {
      pageData: function () {
        let data = this.$store.state.app.static.find((item) => {
          return item.menuId == this.$route.query.menuId
        })
        return data
      },
      curNav() {
        return this.$route.query.plateId
      },
      curName() {
        let plate = this.pageData.children.find((item) => {
          return item.id == this.$route.query.plateId
        })
        return plate.plateName
      }
    },
    watch: {
      $route: {
          handler() {
              console.log('参数改变')
              this.searchList()
          },
          deep: true,
      }
    },
    created() {
      this.searchList()
    },
    methods: {
      handleNav(id) {
      },
      searchList() {
        if(this.$route.query.patent){
          queryPatent(
            {
              name: this.$route.query.search,
              pageIndex: this.currentPage - 1,
              pageSize: this.pageSize
            } 
          ).then((res) => {
            this.articleList = res.list
            this.pageSize = res.pageParam.pageSize
            this.totalPage = res.pageParam.totalCount
          })
        } else {
          searchArticleList(this.$route.query.menuId, this.$route.query.search, this.currentPage - 1,this.pageSize).then((res) => {
            console.log(res.list)
            this.articleList = res.list
            this.pageSize = res.pageParam.pageSize
            this.totalPage = res.pageParam.totalCount
          })
        }
        this.search = ''
      },
      handleChangeCurrent(val) {
        this.currentPage = val
        this.handleNav()
      }
    }
  }
</script>

<style lang="scss">
  .vue-pagination li a, .vue-pagination li button, .vue-pagination .vue-pagination-skip button, .vue-pagination .vue-pagination-skip input {
    font-size: 16px;
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  #search {
    //$themeColor: #3e76fc;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    background-color: #fff;
    .content {
      width: 1200px;
      display: flex;
      .content_left {
        width: 188px;
        background: url("../assets/images/article/listBg.png") no-repeat;
        .left_nav {
          a {
            width: 100%;
            height: 100%;
            display: inline-block;
            font-size: 16px;
            color: #333;
          }
          width: 160px;
          height: 40px;
          font-size: 16px;
          color: #333;
          text-align: center;
          line-height: 40px;
          background-color: #fff;
          margin-top: 10px;
          /*cursor: pointer;*/
          position: relative;
          .nav_img {
            width: 7px;
            height: 11px;
          }
          .white {
            width: 7px;
            height: 11px;
            position: absolute;
            top: 16px;
            right: 4px;
            display: none;
          }
        }
         /*.left_nav_active {
           background-color: $themeColor;
           a {
           width: 100%;
          height: 100%;
          display: inline-block;
             color: #fff;
           }
           .nav_img {
             display: none;
           }
           .white {
             display: block;
           }
         }*/
         .left_nav:hover {
           background-color: $themeColor;
           a {
             color: #fff;
           }
           .nav_img {
             display: none;
           }
           .white {
             display: block;
           }
         }
        .left_nav:first-of-type {
          margin-top: 25px;
        }
        .search_box {
          position: relative;
          .search {
            width: 160px;
            height: 40px;
            margin-top: 25px;
            border-radius: 25px;
            border: 1px solid #ccc;
            padding-left: 10px;
          }
          .search_img {
            width: 22px;
            height: 21px;
            position: absolute;
            right: 34px;
            top: 34px;
          }
        }

        .left_nav:first-of-type {
          margin-top: 25px;
        }
      }
      .content_right {
        width: 1112px;
        min-height: 400px;
        padding-left: 34px;
        .content_header {
          width: 100%;
          height: 86px;
          border-bottom: 1px solid $themeColor;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .title {
            font-size: 28px;
            color: $themeColor;
          }
          .card {
            font-size: 14px;
            color: #333;
          }
        }
        .article_box {
          width: 100%;
          min-height: 400px;
          .article_list a {
            height: 54px;
            font-size: 16px;
            border-bottom: 1px solid #e1e1e1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .article_title {
              color: #333;
              img {
                width: 10px;
                height: 12px;
                margin-right: 10px;
              }
            }
            .date {
              color: #666;
            }
          }
        }
        .data_null{
          position: relative;
          top: -300px;
          left: 0;
          text-align: center;
        }
        .page {
          margin: 70px 0 145px 0;
          display: flex;
          justify-content: center;
          .vue-pagination {
            font-size: 16px;
            color: #999;
            .vue-pagination li a {
              font-size: 16px !important;
            }
          }
        }
      }
    }
  }
</style>
